import styled from "styled-components";

export const StyledValidation = styled.div`
    color: ${p => p.theme.c.wrong};
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 4px;
    margin-top: -6px;
    .i-alert {
        position: relative;
        font-size: 14px;
        top: 2px;
        margin-right: 2px;
        display: inline-block;
        color: ${p => p.theme.c.wrong};
    }
`;
